import DashboardSummaryCountsWidget from '../../../components/DashboardSummaryCountsWidget/SummaryCountWidget'
import SvgIconChannels from '../../../assets/inlineSvg/icon-channel.svg'
import SvgIconPolicies from '../../../assets/inlineSvg/icon-policies.svg'
import SvgIconMembers from '../../../assets/inlineSvg/icon-members.svg'
import { RootState } from '../../../rootReducer'
import {
  fetchSlackScannedChannelsCount,
  fetchSlackSummaryData,
  ISlackSummary
} from '../../summary/summarySlice'
import useUrlContext from '../../../hooks/useUrlContext'
import { mockSlackSummaryCountWidgetData } from '../renderer/utils/widgetMockdata'
import { getUniqueWidgetIndex, UNIQUE_WIDGET_INDEX } from '../mainDashboardv2/constants'
import { connect } from 'react-redux'
import { useIntl } from 'react-intl'
import React, { useEffect } from 'react'

interface OwnProps {
  useMockData?: boolean
  widgetDatasourceId?: string
  widgetDashboardId?: string
}

interface DispatchProps {
  fetchSlackScannedChannelsCount: (args: {
    datasourceId: string
    [UNIQUE_WIDGET_INDEX]?: string
  }) => void
  fetchSlackSummaryData: (args: { datasourceId: string; [UNIQUE_WIDGET_INDEX]?: string }) => void
}

interface StateProps {
  widgetData: ISlackSummary
  policiesCount?: number
}

type MsVivaEngageSummaryCountComponentProps = OwnProps & StateProps & DispatchProps

const SlackSummaryCounts = ({
  fetchSlackScannedChannelsCount,
  fetchSlackSummaryData,
  widgetData: { membersCount, channelsCount, scannedChannelsCount },
  policiesCount,
  useMockData = false,
  widgetDatasourceId,
  widgetDashboardId
}: MsVivaEngageSummaryCountComponentProps) => {
  const intl = useIntl()
  const context = useUrlContext()
  const datasourceId = widgetDatasourceId ? widgetDatasourceId : context.contextFilters.datasourceId
  const widgetIndex = getUniqueWidgetIndex(widgetDashboardId, widgetDatasourceId)

  const channelsCountFormatted = intl.formatNumber(channelsCount || 0, { notation: 'compact' })

  const widgetData = [
    {
      icon: <SvgIconChannels />,
      text: intl.formatMessage({ id: 'dashboard.msVivaEngage.widget.text.communities' }),
      secondaryText: intl.formatMessage(
        { id: 'dashboard.msVivaEngage.widget.secondaryText.communities' },
        { count: channelsCountFormatted }
      ),
      count: scannedChannelsCount || 0
    },
    {
      icon: <SvgIconPolicies />,
      text: intl.formatMessage({ id: 'dashboard.dataSource.widget.text.policies' }),
      count: policiesCount || 0
    },
    {
      icon: <SvgIconMembers />,
      text: intl.formatMessage({ id: 'dashboard.dataSource.widget.text.members' }),
      count: membersCount || 0
    }
  ]

  useEffect(() => {
    if (useMockData) return
    if (datasourceId) {
      fetchSlackScannedChannelsCount({ datasourceId, [UNIQUE_WIDGET_INDEX]: widgetIndex })
      fetchSlackSummaryData({ datasourceId, [UNIQUE_WIDGET_INDEX]: widgetIndex })
    }
  }, [
    datasourceId,
    fetchSlackScannedChannelsCount,
    fetchSlackSummaryData,
    widgetIndex,
    useMockData
  ])

  const isPoliciesCountAvailable = policiesCount !== undefined
  const isChannelsCountAvailable = channelsCount !== undefined
  const isMembersCountAvailable = membersCount !== undefined
  const countsAvailable =
    isChannelsCountAvailable && isMembersCountAvailable && isPoliciesCountAvailable
  const showLoader = !countsAvailable

  return (
    <DashboardSummaryCountsWidget
      summaryItems={widgetData}
      showLoader={showLoader}
      useMockData={useMockData}
    />
  )
}

const mapStateToProps = (state: RootState, ownProps: OwnProps): StateProps => {
  {
    const widgetIndex = getUniqueWidgetIndex(
      ownProps.widgetDashboardId,
      ownProps.widgetDatasourceId
    )
    return {
      widgetData: ownProps?.useMockData
        ? mockSlackSummaryCountWidgetData.summaryCount
        : state.summary.widgetSlackSummaryData?.[widgetIndex] || {},
      policiesCount: ownProps?.useMockData
        ? mockSlackSummaryCountWidgetData.policiesCount
        : state.dashboardSummaryCounts.policiesCount?.[widgetIndex]
    }
  }
}

const mapDispatchToProps = {
  fetchSlackScannedChannelsCount,
  fetchSlackSummaryData
}

export default connect(mapStateToProps, mapDispatchToProps)(SlackSummaryCounts)
